@if (isOpened) {
  <div class="pave-explicatif_content" role="note" [ngStyle]="customStyles">
    @if (!disableArrow && (leftOffset$ | async) !== -1) {
      <div class="pave-explicatif_arrow" [style.left]="(leftOffset$ | async)! - clientLeftOffset - 16 + 'px'"></div>
    }
    @if (hasClosedButton) {
      <button mat-icon-button class="close-button" data-dismiss="alert" data-tfa="pave-explicatif_button-close" (click)="isOpened = false" matTooltip="fermer" aria-label="fermer">
        <mat-icon data-tfa="cancel">close</mat-icon>
      </button>
    }
    @if (messageString) {
      <span class="message-string-container">{{ messageString }}</span>
    }
    @if (messageTemplate) {
      <span>
        <ng-container [ngTemplateOutlet]="messageTemplate"></ng-container>
      </span>
    }
  </div>
}
